// Dependencies
import { InputText } from 'primereact/inputtext';
import React, { Component } from 'react';
import AllowancePresenceTicketDetailComponent from './allowance-presence-ticket-detail/allowance-presence-ticket-detail';
import AllowanceMealHotelTravelComponent from './allowance-meal-hotel-travel-detail/allowance-meal-hotel-travel-detail';
import AllowanceInvoiceDetailComponent from './allowance-invoice-detail/allowance-invoice-detail';
import AllowanceDailyDetailComponent from './allowance-daily-detail/allowance-daily-detail';

// Multi lang
import { withTranslation } from 'react-multi-lang';
import { ALLOWANCE_APPROVED, ALLOWANCE_PAYED, ALLOWANCE_TYPE_MEAL_TRAVEL, ALLOWANCE_TYPE_PRESENCE_TICKET, ALLOWANCE_TYPE_REPRESENTATION, DECISION_WAIT_EXPENSE_SUBMISSION, DECISION_WAIT_PAYMENT, DIRECTION_APPROVAL, FINANCE_APPROVAL, ORGANIC_UNIT_APPROVAL } from '../../../common/constants';
import { getPrettyDate } from '../../../common/utils/date-utils';

// Styling
import './allowance-detail.scss';

class AllowanceDetailComponent extends Component {

    getAllowanceStateControl(allowance) {
        if(allowance.allowanceStateId === ORGANIC_UNIT_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === FINANCE_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DIRECTION_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-payment")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_EXPENSE_SUBMISSION) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-expense-submission")}</span>;
        }
        else if(allowance.allowanceStateId === ALLOWANCE_APPROVED || allowance.allowanceStateId === ALLOWANCE_PAYED){
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("allowances.form.approved")}</span>;
        }
        else {
          return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("allowances.form.not-approved")}</span>;
       }
    }

    amountBodyTemplate(amount) {

        if(amount.toString().includes(".")) {
            let amountParts = amount.toString().split(".");

            if(amountParts[1].length === 1) {
                return amount + "0 €";
            }
            else {
                return amount + " €";
            }     
        }
        else {
            return amount + ".00 €";
        }       

        return "";
    }

    getAllowanceTotal() {
        let total = 0;

        if(this.props.allowance.dailyData !== null) {
            if(this.props.allowance.dailyData.total !== null) {
                total += this.props.allowance.dailyData.total;
            }
        }

        if(this.props.allowance.invoiceData !== null) {
            if(this.props.allowance.invoiceData.kmsValue !== null) {
                total += this.props.allowance.invoiceData.kmsValue;
            }
    
            if(this.props.allowance.invoiceData.hotelValue !== null) {
                total += this.props.allowance.invoiceData.hotelValue;
            }
    
            if(this.props.allowance.invoiceData.mealValue !== null) {
                total += this.props.allowance.invoiceData.mealValue;
            }
    
            if(this.props.allowance.invoiceData.busValue !== null) {
                total += this.props.allowance.invoiceData.busValue;
            }
    
            if(this.props.allowance.invoiceData.trainValue !== null) {
                total += this.props.allowance.invoiceData.trainValue;
            }
    
            if(this.props.allowance.invoiceData.taxiValue !== null) {
                total += this.props.allowance.invoiceData.taxiValue;
            }
    
            if(this.props.allowance.invoiceData.planeValue !== null) {
                total += this.props.allowance.invoiceData.planeValue;
            }
        }

        return total;
    }

    getPersonalAddress() {
        var address = "";

        if(this.props.associate.personalData.streetTypePlaceholder !== null) {
            address += this.props.associate.personalData.streetTypePlaceholder;
        }

        if(this.props.associate.personalData.addressLine !== null) {
            address += " " + this.props.associate.personalData.addressLine;
        }

        if(this.props.associate.personalData.doorNumber !== null) {
            address += " " + this.props.associate.personalData.doorNumber;
        }

        if(this.props.associate.personalData.doorFloor !== null) {
            address += " " + this.props.associate.personalData.doorFloor;
        }

        return address;
    }

  render() {

    return (
                this.props.allowance !== null ?
                    <div>
                        <div className="grid mgt-10">
                            <div className="col-6 t-align-left">
                                <label style={{fontSize: "16px"}}><b>{this.props.t("allowances.dialog.common.form.allowance-ref")} {this.props.allowance.allowanceRef}</b></label>
                            </div>
                            <div className="col-6 t-align-right">
                                {this.getAllowanceStateControl(this.props.allowance)}
                            </div>
                        </div>
                        <div className="grid mgt-20">
                            <div className="col-12">
                                <label><b>{this.props.t("allowances.dialog.tabs.step-1")}</b></label>
                            </div>
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="organic-unit">{this.props.t("allowances.dialog.common.form.organic-unit")}</label>
                                    <InputText disabled value={this.props.organicUnit.name} id="organic-unit" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="organic-unit-responsible">{this.props.t("allowances.dialog.common.form.organic-unit-responsible")}</label>
                                    <InputText disabled value={this.props.organicUnit.responsible} id="organic-unit-responsible" type="text" />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="organic-unit-role">{this.props.t("allowances.dialog.common.form.organic-unit-role")}</label>
                                    <InputText disabled value={this.props.allowance.allowanceTypeId === ALLOWANCE_TYPE_REPRESENTATION ? "Representante" : this.props.organicUnit.associateRole} id="organic-unit-role" type="text" />
                                </div>
                            </div>
                        </div>
                        <div className="grid mgt-20">
                            <div className="col-12">
                                <label><b>{this.props.t("allowances.dialog.tabs.step-2")}</b></label>
                            </div>
                            <div className="col-12 lg:col-8">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="name">{this.props.t("allowances.dialog.common.form.name")}</label>
                                    <InputText disabled value={this.props.associate.personalData.name} id="name" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="ballot">{this.props.t("allowances.dialog.common.form.ballot")}</label>
                                    <InputText disabled value={this.props.ballot !== null ? this.props.ballot.ballotRef : null} id="ballot" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="fiscalNumber">{this.props.t("allowances.dialog.common.form.fiscal-number")}</label>
                                    <InputText disabled value={this.props.associate.personalData.nif} id="fiscalNumber" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="niss">{this.props.t("allowances.dialog.common.form.niss")}</label>
                                    <InputText disabled value={this.props.associate.personalData.niss} id="niss" type="text" />
                                </div>
                            </div>
                            <div className="col-12 lg:col-4">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="iban">{this.props.t("allowances.dialog.common.form.iban")}</label>
                                    <InputText disabled value={this.props.associate.personalData.iban} id="iban" type="text" />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="address">{this.props.t("allowances.dialog.common.form.address")}</label>
                                    {
                                        this.props.associate.professionalData !== undefined ? 
                                            <InputText disabled value={this.props.associate.professionalData.fullAddress + " " + this.props.associate.professionalData.cP4 + "-" + this.props.associate.professionalData.cP3 + " " + this.props.associate.professionalData.city} id="address" type="text" />
                                            :
                                            <InputText disabled value={this.getPersonalAddress() + " " + this.props.associate.personalData.cP4 + "-" + this.props.associate.personalData.cP3 + " " + this.props.associate.personalData.city} id="address" type="text" />
                                    }                                
                                </div>
                            </div>
                        </div>
                        <div className="grid mgt-20">
                            <div className="col-12">
                                <label><b>{this.props.t("allowances.dialog.common.form.meeting-title")}</b></label>
                            </div>
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="departure-place">{this.props.t("allowances.dialog.common.form.departure-place")}</label>
                                    <InputText disabled value={this.props.allowance.departurePlace} id="departure-place" type="text"/>
                                </div>
                            </div>
                            {
                                this.props.allowance.checkpointPlace !== null ?
                                    <div className="col-12 lg:col-6">
                                        <div className="flex flex-column gap-2">
                                            <label htmlFor="checkpoint-place">{this.props.t("allowances.dialog.common.form.checkpoint-place")}</label>
                                            <InputText disabled value={this.props.allowance.checkpointPlace} id="checkpoint-place" type="text"/>
                                        </div>
                                        <div className="col-12 lg:col-6"></div>
                                    </div>
                                    : null
                            }
                            <div className="col-12 lg:col-6">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="place">{this.props.t("allowances.dialog.common.form.place")}</label>
                                    <InputText disabled value={this.props.allowance.eventPlace} id="place" type="text"/>
                                </div>
                            </div>
                            <div className="col-12 lg:col-3">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="begin-date">{this.props.t("allowances.dialog.common.form.begin-date")}</label>
                                    <InputText disabled value={getPrettyDate(this.props.allowance.eventBeginDate)} id="begin-date" type="text"/>
                                </div>                        
                            </div>
                            <div className="col-12 lg:col-3">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="end-date">{this.props.t("allowances.dialog.common.form.end-date")}</label>
                                    <InputText disabled value={getPrettyDate(this.props.allowance.eventEndDate)} id="end-date" type="text"/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="reason">{this.props.t("allowances.dialog.common.form.reason")}</label>
                                    <InputText disabled value={this.props.allowance.reason} id="reason" type="text"/>
                                </div>
                            </div>
                            {
                                this.props.allowance.allowanceTypeId === ALLOWANCE_TYPE_PRESENCE_TICKET ? 
                                    <AllowancePresenceTicketDetailComponent allowancePresenceTicket={this.props.allowance.allowancePresenceTicket} />
                                    : null
                            }
                            {
                                this.props.allowance.allowanceTypeId === ALLOWANCE_TYPE_MEAL_TRAVEL || this.props.allowance.allowanceTypeId === ALLOWANCE_TYPE_REPRESENTATION ?
                                    <AllowanceMealHotelTravelComponent state={this.props.allowance.allowanceStateId} observations={this.props.allowance.observations} allowanceTravelMealHotel={this.props.allowance.allowanceTravelMealHotel} />
                                    : null
                            }
                            {
                                this.props.allowance.invoiceData !== null ?
                                    <AllowanceInvoiceDetailComponent allowanceRef={this.props.allowance.allowanceRef} allowanceInvoiceData={this.props.allowance.invoiceData} />
                                    : 
                                    null
                            }
                            {
                                this.props.allowance.dailyData !== null ?
                                    <AllowanceDailyDetailComponent allowanceDailyData={this.props.allowance.dailyData} />
                                    : 
                                    null
                            }
                            {
                                this.props.allowance.invoiceData !== null || this.props.allowance.dailyData !== null ?
                                    <div className="col-12 t-align-right">
                                        <p style={{fontSize:'13px', fontWeight:'bold'}}>{this.props.t("checkout.form.total")} {this.amountBodyTemplate(this.getAllowanceTotal()) }</p>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                    : null
        );
    }
}

export default withTranslation(AllowanceDetailComponent);